import React from 'react';
import { Text } from '../Typography';
import { ModalBox } from '../ModalBox';
import {
  ImageCopyWrapper,
  ImageWrapper,
  Image,
  DescriptionTitle,
  DescriptionText,
  MainImageCopy,
  Content,
  ImageWrapperStyle,
  Play,
  Video,
  VideoWrapper,
  PlayStyle,
  MainWrapper,
} from './styles';
import { LongTextContainer } from '../LongText/styles';
import FadeInSection from '../FadeInSection';
import { Grid, GridRow, GridItem } from '../Grid';

import { ImageCopyComponentType, ImageCopyItemType } from './types';
import { MetaBallContainer } from '../MetaBallContainer';
import { getPictureSources } from '../../modules/getPictureSources';
import { RichTextRenderer } from '../RichTextRenderer';

export const ImageCopy = ({
  topRightAsset,
  bottomLeftAsset,
  imageCopyItems,
}: ImageCopyComponentType) => (
  <ImageCopyWrapper>
    <MetaBallContainer
      data-test="metaball-container"
      topRightImage={topRightAsset?.url}
      bottomLeftImage={bottomLeftAsset?.url}
    >
      <div className="sm:py-16 md:py-0">
        <Grid>
          <GridRow columns={16}>
            <GridItem colSpan={10} colStart={4} className="flex flex-wrap justify-between">
              {imageCopyItems?.map((items: ImageCopyItemType) => {
                return (
                  <MainImageCopy columnType={items.columnType} key={items.id}>
                    <FadeInSection>
                      <MainWrapper
                        imagePosition={items.imagePosition}
                        videoPosition={items.videoPosition}
                      >
                        {items?.image && items.image.length !== 0 && items.addImage && (
                          <ImageWrapper
                            imagePosition={items.imagePosition}
                            className={ImageWrapperStyle}
                            video={items.addVideo}
                          >
                            <Image sources={getPictureSources(items?.image?.[0]?.asset?.[0])} />
                          </ImageWrapper>
                        )}
                        {items.addVideo && items.videoId && (
                          <VideoWrapper videoPosition={items.videoPosition}>
                            <Video>
                              <Play className={PlayStyle}>
                                <ModalBox data-test="video-modal-box" videoID={items.videoId} />
                              </Play>
                              <Image
                                sources={getPictureSources(items?.videoPosterImage?.asset?.[0])}
                                alt={items?.videoPosterImage?.asset?.[0].altText}
                              />
                              <Image sources={getPictureSources(items.image?.[0]?.asset?.[0])} />
                            </Video>
                          </VideoWrapper>
                        )}
                        {(items.addTitle || items.addDescription) && (
                          <Content
                            imagePosition={items.imagePosition}
                            image={items.addImage}
                            video={items.addVideo}
                            columnType={items.columnType}
                          >
                            {items.addTitle && (
                              <DescriptionTitle tag="h4" type="sm" data-test="left-title">
                                {items.title}
                              </DescriptionTitle>
                            )}
                            {items.addDescription && items.description && (
                              <DescriptionText data-test="left-description">
                                <LongTextContainer className="long-text-container">
                                  <RichTextRenderer
                                    content={items.description?.json.children}
                                    references={items.description?.references}
                                  />
                                </LongTextContainer>
                              </DescriptionText>
                            )}
                          </Content>
                        )}
                      </MainWrapper>
                    </FadeInSection>
                  </MainImageCopy>
                );
              })}
            </GridItem>
          </GridRow>
        </Grid>
      </div>
    </MetaBallContainer>
  </ImageCopyWrapper>
);
